// constants/locationOptions.ts
export const stateOptions = [
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
  ];
  
  export const cityOptions: { [key: string]: { value: string; label: string }[] } = {
    Maharashtra: [
      { value: "Mumbai", label: "Mumbai" },
      { value: "Pune", label: "Pune" },
      { value: "Nagpur", label: "Nagpur" },
      { value: "Jalgaon", label: "Jalgaon" },
      { value: "Nashik", label: "Nashik" },
      { value: "Aurangabad", label: "Aurangabad" },
    ],
    "Madhya Pradesh": [
      { value: "Bhopal", label: "Bhopal" },
      { value: "Indore", label: "Indore" },
      { value: "Jabalpur", label: "Jabalpur" },
      { value: "Gwalior", label: "Gwalior" },
      { value: "Ujjain", label: "Ujjain" },
    ],
  };
  
  export const cityToStateOptions: Record<string, string> = {
    Mumbai: "Maharashtra",
    Pune: "Maharashtra",
    Nagpur: "Maharashtra",
    Jalgaon: "Maharashtra",
    Nashik: "Maharashtra",
    SambhajiNagar: "Maharashtra",

    Bhopal: "Madhya Pradesh",
    Indore: "Madhya Pradesh",
    Jabalpur: "Madhya Pradesh",
    Gwalior: "Madhya Pradesh",
    Ujjain: "Madhya Pradesh",
  };

  export const allCities = [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Pune", label: "Pune" },
    { value: "Nagpur", label: "Nagpur" },
    { value: "Bhopal", label: "Bhopal" },
    { value: "Indore", label: "Indore" },
    { value: "Jabalpur", label: "Jabalpur" },
    { value: "Gwalior", label: "Gwalior" },
    { value: "Ujjain", label: "Ujjain" },
    { value: "Jalgaon", label: "Jalgaon" },
    { value: "Nashik", label: "Nashik" },
  ];